<template>
  <button type="button" :class="buttonClasses" :aria-label="isUpvote ? 'Up vote' : 'Down vote'" v-on="$listeners">
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { computed } from '@nuxtjs/composition-api';

type WarRoomVoteButtonProps = {
  isUpvote?: boolean;
  isUpvoted?: boolean;
  isDownvote?: boolean;
  isDownvoted?: boolean;
  isDisabled?: boolean;
};

const props = withDefaults(defineProps<WarRoomVoteButtonProps>(), {
  isUpvote: false,
  isUpvoted: false,
  isDownvote: false,
  isDownvoted: false,
  isDisabled: false,
});

const buttonClasses = computed(() => ({
  'war-room-vote-button': true,
  'war-room-vote-button--upvoted': props.isUpvoted,
  'war-room-vote-button--downvoted': props.isDownvoted,
  'war-room-vote-button--disabled': props.isDisabled,
}));
</script>

<style scoped lang="scss">
.war-room-vote-button {
  outline: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  border: none;
  padding: 0;
  color: var(--theme-color-text);
  opacity: 0.3;
  transition: opacity 0.3s;
  line-height: 0;

  &:hover {
    opacity: 0.5;
  }

  &--upvoted {
    color: var(--blue-60);
    opacity: 1;

    &:hover {
      opacity: 1;
    }
  }

  &--downvoted {
    color: var(--red-50);
    opacity: 1;

    &:hover {
      opacity: 1;
    }
  }

  &--disabled {
    pointer-events: none;
    opacity: 0.1;
    cursor: not-allowed;

    &:hover {
      opacity: 0.1;
    }
  }
}
</style>
